import {Question} from './question';
import {PostSyncAction} from './post-sync-action';
import {Terminal} from './terminal';
import {ImportRequirement} from './import-requirement';
import {QuestionTypeEnum, QuestionTypeEnumUtil} from './questionTypeEnum';
import {Inject} from 'typescript-ioc/es6';
import {JsonObject, JsonProperty} from 'json2typescript';


@JsonObject('Questionnaire')
export class Questionnaire {

    @JsonProperty('id',Number)
    id = 0;

    @JsonProperty('projectId',Number)
    projectId = 0;

    @JsonProperty('name',String)
    name='';

    @JsonProperty('src',String)
    src='';

    // a questionnaire whose questions are yet to be defined
    @JsonProperty('languages',[String],true)
    languages:string[] = [];

    // a questionnaire whose questions are yet to be defined
    @JsonProperty('questions',[Question],true)
    questions:Question[] = [];

    @JsonProperty('submitAction',String,true)
    submitAction = '';

    @JsonProperty('email',Boolean,true)
    email=false;

    @JsonProperty('sms',Boolean,true)
    sms=false;

    // TODO: To be removed upon confirmation. maybe a reference list to the terminals that uses this questionnaire
    @JsonProperty('terminals',[Terminal],true)
    terminals: Terminal[] = [];

    @JsonProperty('postSyncActions',[PostSyncAction],true)
    postSyncActions: PostSyncAction[] = [];

    importRequirement:ImportRequirement;

    @JsonProperty('isSelected',Boolean,true)
    isSelected = false;

    @JsonProperty('createdDate',String,true)
    createdDate = '';

    @JsonProperty('lastModifiedDate',String,true)
    lastModifiedDate = '';

    @JsonProperty('type',String,true)
    type = '';

    @JsonProperty('tags',[String],true)
    tags:string[] = [];

    @JsonProperty('pivotQuestion',Number)
    pivotQuestion:number;

    @JsonProperty('fullScreen',Boolean,true)
    fullScreen = false;

    @JsonProperty('loaderClass',String,true)
    loaderClass = '';

    @Inject
    questionTypeUtil:QuestionTypeEnumUtil;

    constructor() {}

    /*constructor(json:any) {
      this.id = json.id;
      this.projectId = json.projectId;
      this.name = json.name;
      this.languages = json.languages;
      this.email = json.email;
      this.sms = json.sms;
      this.submitAction = json.submitAction;
      this.src = json.src;
      this.languages = new Array<string>();
      this.createdDate = json.createdDate;
      this.lastModifiedDate = json.lastModifiedDate;
      this.pivotQuestion = json.pivotQuestion;
      this.fullScreen = json.fullScreen;
      this.loaderClass = json.loaderClass;

      this.type = json.type;


      this.questions = new Array<Question>();
      if(json.languages!=null) {
        for (let i = 0; i < json.languages.length; i++) {
          this.languages.push(json.languages[i]);
        }
      }

      if(json.questions!=null) {
        for (let i = 0; i < json.questions.length; i++) {
          const quest = new Question(json.questions[i]);
          if(QuestionTypeEnumUtil.getType(quest.type) === QuestionTypeEnum.email) {
            this.email = true;
          }
          if(QuestionTypeEnumUtil.getType(quest.type) === QuestionTypeEnum.sms) {
            this.sms = true;
          }
          this.questions.push(quest);
        }
      }



      this.terminals = new Array<Terminal>();

      if(json.terminals!=null) {
        for (let i = 0; i < json.terminals.length; i++) {
          this.terminals.push(Json2TypescriptUtil.getJsonConvertInstance().deserializeObject(json.terminals[i],Terminal));// new Terminal(json.terminals[i]));
        }
      }

      this.postSyncActions = new Array<PostSyncAction>();
      if(json.postSyncActions!= null) {
        for (let i = 0; i < json.postSyncActions.length; i++) {
          this.postSyncActions.push(Object.assign(new PostSyncAction(), JSON.parse(json.postSyncActions)));
        }
      }


    }*/


    public getQuestionByType(type:QuestionTypeEnum):number {
      for(const quest of this.questions) {
        if(QuestionTypeEnumUtil.getType(quest.type) === type) {
          return quest.no;
        }
      }
      return -1;
    }

    public getTerminal():Terminal {
      for(const term of this.terminals) {
        if(term.associatedQuestionnaireId === this.id) {
          return term;
        }
      }
      return null;
    }


   /* public performQuestionsTypeCheck() {

      for(const q of this.questions) {
        if(QuestionTypeEnumUtil.getType(q.type) === QuestionTypeEnum.email) {
          this.email = true;
        }
        if(QuestionTypeEnumUtil.getType(q.type) === QuestionTypeEnum.sms) {
          this.sms = true;
        }
      }

    }*/
}



